export const SSO_SESSION_ACTIVE = 'SSO_SESSION_ACTIVE';
export const SSO_SESSION_INACTIVE = 'SSO_SESSION_INACTIVE';
export const SSO_SESSION_ERROR = 'SSO_SESSION_ERROR';
export const GEO_IP_SUCCESS = 'GEO_IP_SUCCESS';
export const GEO_IP_FAILED = 'GEO_IP_FAILED';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';

export function ssoSessionActive(token) {
  return {
    type: SSO_SESSION_ACTIVE,
    accessToken: token,
  };
}

export function ssoSessionInactive() {
  return {
    type: SSO_SESSION_INACTIVE,
  };
}

export function ssoSessionError(e) {
  return {
    type: SSO_SESSION_ERROR,
    err: e,
  };
}

export function ipCountrySuccess(country) {
  return {
    type: GEO_IP_SUCCESS,
    payload: { country },
  };
}

export function ipCountryFailed(err) {
  return {
    type: GEO_IP_FAILED,
    err,
  };
}

export function userLoggedOut() {
  return {
    type: USER_LOGGED_OUT,
  };
}



// WEBPACK FOOTER //
// ./src/actions/auth.js